import React, { useContext, useState } from "react";
import { Td, Tooltip, Tr } from "@chakra-ui/react";
import MenuRUD from "components/Menu/MenuRUD";
import styled from "styled-components/macro";
import { IconGeneric } from "styled/Icons.styled";
import { BsCheckCircleFill } from "react-icons/bs";
import { __ShowCities } from "request/configuration/__Cities";

import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { useSelector } from "react-redux";
import environment from "constants/apiConst";
import {
  __ACTIVAR,
  __DESACTIVAR
} from "request/configuration/__Activar_Desactivar";
import { ConfigIconStatus } from "./components/LoadingConfig";

const TdState = styled(Td)`
  color: ${(props) => (props.text === 1 ? "#58D68D" : "#F1948A")};
`;
const TbodyCities = ({ data }) => {
  const token = useSelector((state) => state.auth.dataUser.token);
  const { setUpdate, update, setLoading } = useContext(
    ConfigurationCRUDContext
  );
  const [openAlert] = AlertErrorAlert();
  const [loadingIcons, setLoadingIcons] = useState(false);

  const desactivarAndActivar = async (result) => {
    setLoadingIcons(true);
    // setLoading(true);
    try {
      const resultado =
        result === 1
          ? await __DESACTIVAR(token, environment.CITIES_DESACTIVAR, data.id)
          : await __ACTIVAR(token, environment.CITIES_ACTIVAR, data.id);
      if (resultado.data.status.code !== 200) {
        openAlert(resultado.data.status.message, "error");
      } else {
        setUpdate(!update);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingIcons(false);
      // setLoading(false);
    }
  };

  const handleState = async () => {
    try {
      const res = await __ShowCities(token, data.id);
      const result = res.data.status.data.status_city;
      desactivarAndActivar(result);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Tr>
      <Td className="text-center">{data?.name_city}</Td>
      <Td className="text-center">{data?.code_city}</Td>
      <Td className="text-center">{data?.abbreviation}</Td>
      <Td className="text-center">{data?.name_department}</Td>
      <Tooltip
        placement="top"
        hasArrow
        label={data?.status_city === 1 ? "Desactivar" : "Activar"}
      >
        <TdState
          onClick={handleState}
          className="text-center"
          isNumeric
          text={data?.status_city}
        >
          <ConfigIconStatus loading={loadingIcons} status={data?.status_city} />
        </TdState>
      </Tooltip>
      <Td className="text-center" isNumeric>
        <MenuRUD data={data} />
      </Td>
    </Tr>
  );
};

export default TbodyCities;
